webpackJsonp([44341822457911],{

/***/ 43:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portfolios = function (_React$Component) {
	  _inherits(Portfolios, _React$Component);
	
	  function Portfolios() {
	    _classCallCheck(this, Portfolios);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Portfolios.prototype.componentDidMount = function componentDidMount() {
	    var isBrowser = typeof window !== 'undefined';
	    var AOS = isBrowser ? __webpack_require__(3) : undefined;
	    this.aos = AOS;
	    this.aos.init();
	  };
	
	  Portfolios.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.aos.refresh();
	  };
	
	  Portfolios.prototype.render = function render() {
	    return _react2.default.createElement(
	      'section',
	      { className: 'portfolio-cards-container' },
	      _react2.default.createElement('img', { alt: 'Portfolio trend graph', src: (0, _gatsbyLink.withPrefix)('images/graphics/portfolio-trend.svg'), className: 'portfolio-trend-image' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-portfolio defensive' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'card-title' },
	              'Defensive'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Lower risk, Lower return'
	              ),
	              _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'card-caption' },
	                  'Allocation:'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'progress' },
	                  _react2.default.createElement('div', { className: 'progress-bar bg-shares--light w-35', role: 'progressbar', 'aria-valuenow': '35', 'aria-valuemin': '0', 'aria-valuemax': '100' }),
	                  _react2.default.createElement('div', { className: 'progress-bar bg-bonds w-65', role: 'progressbar', 'aria-valuenow': '65', 'aria-valuemin': '0', 'aria-valuemax': '100' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'allocation-block d-flex justify-content-around' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'shares-percentage' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '35%'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Shares'
	                  )
	                ),
	                _react2.default.createElement('span', { className: 'divider' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bonds-percentage' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '65%'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Bonds'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'badge badge-light' },
	                'Core'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-portfolio balanced' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'card-title' },
	              'Balanced'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Medium risk, Medium return'
	              ),
	              _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'card-caption' },
	                  'Allocation:'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'progress' },
	                  _react2.default.createElement('div', { className: 'progress-bar bg-shares w-60', role: 'progressbar', 'aria-valuenow': '60', 'aria-valuemin': '0', 'aria-valuemax': '100' }),
	                  _react2.default.createElement('div', { className: 'progress-bar bg-bonds w-40', role: 'progressbar', 'aria-valuenow': '40', 'aria-valuemin': '0', 'aria-valuemax': '100' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'allocation-block d-flex justify-content-around' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'shares-percentage' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '60%'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Shares'
	                  )
	                ),
	                _react2.default.createElement('span', { className: 'divider' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bonds-percentage' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '40%'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Bonds'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'badge badge-light' },
	                'Core'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-portfolio growth' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'card-title' },
	              'Growth'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'High risk, Higher return'
	              ),
	              _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'card-caption' },
	                  'Allocation:'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'progress' },
	                  _react2.default.createElement('div', { className: 'progress-bar bg-shares w-95', role: 'progressbar', 'aria-valuenow': '35', 'aria-valuemin': '0', 'aria-valuemax': '95' }),
	                  _react2.default.createElement('div', { className: 'progress-bar bg-bonds--light w-5', role: 'progressbar', 'aria-valuenow': '5', 'aria-valuemin': '0', 'aria-valuemax': '100' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'allocation-block d-flex justify-content-around' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'shares-percentage' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '95%'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Shares'
	                  )
	                ),
	                _react2.default.createElement('span', { className: 'divider' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bonds-percentage' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '5%'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Bonds'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'badge badge-light' },
	                'Core'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Portfolios;
	}(_react2.default.Component);
	
	exports.default = Portfolios;
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Themes = function (_React$Component) {
	  _inherits(Themes, _React$Component);
	
	  function Themes(props) {
	    _classCallCheck(this, Themes);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  //==============
	  // React Methods
	  //==============
	
	  Themes.prototype.componentDidMount = function componentDidMount() {
	    var isBrowser = typeof window !== 'undefined';
	    var AOS = isBrowser ? __webpack_require__(3) : undefined;
	    this.aos = AOS;
	    this.aos.init();
	  };
	
	  Themes.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.aos.refresh();
	  };
	
	  //=================
	  // Render Component
	  //=================
	
	  Themes.prototype.render = function render() {
	    return _react2.default.createElement(
	      'section',
	      { className: 'theme-cards-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-theme' },
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/themes/technology.jpg'), className: 'card-img-top', alt: 'Technology theme image' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Technology'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Invest your money towards the brands you rely on everyday. Add the most innovative companies to your portfolio including Apple, Facebook, Amazon and Google.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex justify-content-between align-items-center' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'cta-link', href: 'http://www.betashares.com.au/fund/nasdaq-100-etf/#each-overview', target: '_blank' },
	                  'Learn more'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'badge badge-light' },
	                  'Theme'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-theme' },
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/themes/ethical.jpg'), className: 'card-img-top', alt: 'Ethical theme image' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Ethical'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Invest where you know you are doing good (and as importantly, not doing harm). Add \u201CClimate Leaders\u201D from a broad range of global locations to your portfolio.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex justify-content-between align-items-center' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://www.betashares.com.au/fund/global-sustainability-leaders-etf/', className: 'cta-link', target: '_blank' },
	                  'Learn more'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'badge badge-light' },
	                  'Theme'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-theme' },
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/themes/health.jpg'), className: 'card-img-top', alt: 'Health theme image' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Health'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Invest your money towards companies keeping us well. Add biotechnology, healthcare, medical equipment and pharmaceutical companies to your portfolio.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex justify-content-between align-items-center' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.blackrock.com/au/individual/products/273430/ishares-global-healthcare-etf', className: 'cta-link', target: '_blank' },
	                  'Learn more'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'badge badge-light' },
	                  'Theme'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-theme' },
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/themes/asia.jpg'), className: 'card-img-top', alt: 'Asia theme image' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Asia'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Invest towards large, established Asian companies listed in China, Hong Kong, Macau, Singapore, South Korea, and Taiwan.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex justify-content-between align-items-center' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.blackrock.com/au/individual/products/273416/ishares-asia-50-etf', className: 'cta-link', target: '_blank' },
	                  'Learn more'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'badge badge-light' },
	                  'Theme'
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Themes;
	}(_react2.default.Component);
	
	exports.default = Themes;
	module.exports = exports['default'];

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _aos = __webpack_require__(3);
	
	var _aos2 = _interopRequireDefault(_aos);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _Banner = __webpack_require__(18);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Themes = __webpack_require__(32);
	
	var _Themes2 = _interopRequireDefault(_Themes);
	
	var _Portfolios = __webpack_require__(31);
	
	var _Portfolios2 = _interopRequireDefault(_Portfolios);
	
	__webpack_require__(333);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PressPage = function (_React$Component) {
	  _inherits(PressPage, _React$Component);
	
	  function PressPage(props) {
	    _classCallCheck(this, PressPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  PressPage.prototype.componentDidMount = function componentDidMount() {
	    var isBrowser = typeof window !== 'undefined';
	    var AOS = isBrowser ? __webpack_require__(3) : undefined;
	    this.aos = AOS;
	    this.aos.init();
	  };
	
	  PressPage.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.aos.refresh();
	  };
	
	  PressPage.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'press-page' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Press | Invest as you spend'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'Please get in touch with us for any media enquiries.' })
	      ),
	      _react2.default.createElement(_Banner2.default, {
	        ctaMode: true,
	        buttonMode: true,
	        contactLink: 'hello@firststep.co',
	        buttonLink: '/documents/FirstStep-Presskit.pdf',
	        buttonText: 'Download Press Kit',
	        title: 'Press',
	        tagline: 'For media enquiries, please contact'
	      }),
	      _react2.default.createElement(
	        'section',
	        { className: 'app-screen invest', 'data-aos': 'fade-up', 'data-aos-once': true },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row align-items-center' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 content' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'section-left' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    'About FirstStep'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'At FirstStep we have reimagined the way we invest. The FirstStep account is designed to help you automatically reach your saving goals as you focus on the important things life.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'FirstStep was founded in 2015 with a mission to make investing accessible using new technology to lower investment minimums. In December 2016 we became an ASIC registered managed investment scheme, and an experienced and dedicated team of \u2018wealthtech\u2019 professionals.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'FirstStep went live on iOS and Android in January 2018 and thousands of Australians have downloaded FirstStep to reach their saving goal.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 phone' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'section-right text-right' },
	                  _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('images/graphics/app-screens/iphone_account_dark.png'), className: 'iphone-img img-fluid w-75', alt: 'Phone screen account graph' })
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'text-center' },
	          'Recent press'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 col-sm-6 col-md-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card card-media-article' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Apr 2018'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-body' },
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener', href: 'https://www.businessinsider.com.au/finnies-awards-australian-fintech-startups-wealth-planning-industry-2018-4', className: 'img-container' },
	                  _react2.default.createElement('img', { className: 'img-fluid w-75', src: (0, _gatsbyLink.withPrefix)('/images/logos/press-articles/business-insider.png'), alt: 'Business Insider logo' })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'card-text' },
	                  'The Australian fintech startups taking on the wealth planning industry.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 col-sm-6 col-md-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card card-media-article' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Mar 2018'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-body' },
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener', href: 'http://www.abc.net.au/news/2018-03-05/electronic-piggybanks-for-the-tap-and-go-age/9505854', className: 'img-container' },
	                  _react2.default.createElement('img', { className: 'img-fluid', src: (0, _gatsbyLink.withPrefix)('/images/logos/press-articles/ABC.png'), alt: 'ABC logo' })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'card-text' },
	                  'Use fintech apps to grow your wealth.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 col-sm-6 col-md-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card card-media-article' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Mar 2018'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-body' },
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener', href: 'http://www.theage.com.au/money/how-small-change-can-make-you-a-millionaire-20160316-gnl3f0', className: 'img-container' },
	                  _react2.default.createElement('img', { className: 'img-fluid', src: (0, _gatsbyLink.withPrefix)('/images/logos/press-articles/the-age.png'), alt: 'The Age logo' })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'card-text' },
	                  'Micro-investing apps creating electronic piggybanks for the tap-and-go age.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 col-sm-6 col-md-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card card-media-article' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Mar 2017'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-body' },
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener', href: 'http://www.smh.com.au/money/how-small-change-can-make-you-a-millionaire-20160316-gnl3f0.html', className: 'img-container' },
	                  _react2.default.createElement('img', { className: 'img-fluid', src: (0, _gatsbyLink.withPrefix)('/images/logos/press-articles/smh.png'), alt: 'Sydney Morning Herald logo' })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'card-text' },
	                  'How small change can make you a millionaire.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 col-sm-6 col-md-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card card-media-article' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Mar 2017'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-body' },
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener', href: 'http://www.startupsmart.com.au/advice/business-planning/agent-of-change-new-startup-helps-young-investors-take-first-steps/', className: 'img-container' },
	                  _react2.default.createElement('img', { className: 'img-fluid', src: (0, _gatsbyLink.withPrefix)('/images/logos/press-articles/startup-smart.png'), alt: 'Startup Smart logo' })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'card-text' },
	                  'How small change can make you a millionaire.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 col-sm-6 col-md-4' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card card-media-article' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Aug 2015'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card-body' },
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', rel: 'noopener', href: 'http://www.startupdaily.net/2015/08/firststep-wants-get-millennials-investing-virtual-loose-change-faces-competition-acorns/', className: 'img-container' },
	                  _react2.default.createElement('img', { className: 'img-fluid', src: (0, _gatsbyLink.withPrefix)('/images/logos/press-articles/startup-daily.png'), alt: 'Startup Daily logo' })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'card-text' },
	                  'Agent of change: New startup helps young investors take first steps.'
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PressPage;
	}(_react2.default.Component);
	
	exports.default = PressPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-press-index-js-035bcdcb67c86a56c93d.js